module.exports = __webpack_public_path__ + "img/speed-gauge.15a6b2c.svg";